import { $closest, $data, $delegate, $el, $find, $replaceWith } from 'fxdom/es';
import { go, html } from 'fxjs/es';
import { MuiF } from '../../../../../Mui/F/Function/module/MuiF.js';
import { NewMakerComponentsImageDropBoxF } from '../../../ImageDropBox/F/Function/module/NewMakerComponentsImageDropBoxF.js';
import { NewMakerComponentsImageSelectFrameMuiF } from '../Mui/module/NewMakerComponentsImageSelectFrameMuiF.js';
import { MShopUtilF } from '@modules/MShop/Util/F/Function/module/MShopUtilF.js';

export const openImageSelectorFrame = async (data, selectFunc) => {
  return MuiF.openFrame(NewMakerComponentsImageSelectFrameMuiF.frame, async (frame, page, [tab]) => {
    frame.animation = true;
    frame.prev_frame_show = true;
    frame.always_remove = true;

    frame.header_height = G.mp.frame.v_height;
    frame.hide_frame_button_type = 'V';
    frame.appended = $.frame_close_bg;

    page.custom_header = () => {
      return html` <div class="maker-image-selector__head">
        ${data.option_group_name}
        <button class="done">${T('selector_frame::done')}</button>
      </div>`;
    };

    tab.makeData = async () => {
      return { ...data, column_length: 3 };
    };

    const height = await MuiF.makeFrameHeight(frame, tab, true);
    frame.height = height + 51;

    frame.closed = () => {
      /*  MuiF.makeFrameHeight 때문에 한번 더 하는건데, 기본 bodyFixed 가 원래의 스크롤 되찾아가야하는 약간의 텀이 필요함 */
      setTimeout(() => {
        MShopUtilF.bodyFixed$(false);
      }, 100);
    };

    frame.removed = () => $.body_fixed(false);
    page.appended = (tab_el) => {
      $.body_fixed(true);
      go(
        tab_el,
        $delegate('click', '.paper_option', ({ currentTarget }) => {
          const selector = go(currentTarget, $closest('.maker-image-selector'));
          const { column_length, option_height, ui_type_pc } = selector.dataset;
          go(
            selector,
            $find('.maker-image-selector__options'),
            $replaceWith(
              $el(
                NewMakerComponentsImageDropBoxF.imageSelectedOptions({
                  ...data,
                  selected_bp_option_id: currentTarget.dataset.id,
                  options: $data(selector),
                  column_length,
                  height: option_height,
                  ui_type_pc,
                }),
              ),
            ),
          );
        }),
        $delegate('click', '.done', ({ currentTarget }) => {
          const selected_bp_option_id = go(currentTarget, $closest('.don_wrapper'), $find('.selected_option'))
            ?.dataset?.id;
          selectFunc(selected_bp_option_id);
          MuiF.closeFrame();
        }),
      );
    };
  });
};
